import { getEnvironment } from "../../helpers/fetching";

export default {
  state: {
    environment: {},
    loading: false,
    error: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setEnvironmentLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setResponse(state, data) {
      state.response = data;
    },
    setEnvironment(state, data) {
      state.environment = data;
      state.loading = false;
      state.error = null;
    },
  },
  actions: {
    fetchEnvironment({ commit }) {
      return new Promise((resolve) => {
        commit("setEnvironmentLoading", true);
        getEnvironment()
          .then((response) => {
            commit("setEnvironment", response);
            commit("setEnvironmentLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            resolve();
          });
      });
    },
    resetEnvironment({ commit }) {
      commit("setEnvironment", {});
    },
  },
};
